import Tryout from './Tryout'
import DashboardGuard from '@/views/dashboard/guards/DashboardGuard'

export default [
    {
        path: '/tryout/:history_hash',
        component: Tryout,
        beforeEnter: DashboardGuard,
        name: 'work',
        meta: {
            analyticsIgnore: true
        }
    }
]
